<template>
  <v-content>
    <v-container fill-width>
      <v-layout align-center column>
        <h1 class="pb-12 task-list-title">{{ $t('select_task') }}</h1>
        <v-expansion-panels :value="0">
          <v-expansion-panel v-for="day in days" :key="day[0]">
            <v-expansion-panel-header>Day {{ day[0] }}: {{ day[1] }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn
                v-for="task in tasksForDay(day[0])"
                :key="task.id"
                class="mb-10"
                rounded
                block
                elevation="5"
                :disabled="task.locked"
                x-large
                :to="'/tasks/' + task.id "
              >
                <v-icon v-if="task.done" size="25" left color="green darken-3">done_outline</v-icon>
                Task {{ task.tasknumber }}: {{ task.name }}
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
    </v-container>
  </v-content>
</template>

<style>
.task-list-title {
  font-size: 100px;
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    tasksForDay(daynumber) {
      return this.tasksWithStatus
        .filter(task => task.day == daynumber)
        .sort((t1, t2) => t1.tasknumber - t2.tasknumber);
    }
  },
  computed: {
    ...mapGetters("user", ["tasksWithStatus"])
  },
  data: () => ({
    days: [
      [1, "Introduction"],
      [2, "Second Day"],
      [3, "Lets learn some more..."]
    ]
  })
};
</script>
